import SettingsTable from '../../../components/tables/SettingsTable'
import React, { useState, useEffect } from 'react'
import { Flex, VStack } from '@chakra-ui/react'
import { useLocation } from 'react-router-dom'
import OrganizationSettings from '../../../components/settings/OrganizationSettings'
import OrganizationsSettings from '../../../components/settings/OrganizationsSettings'
import PaymentsSettings from '../../../components/settings/PaymentsSettings'
import ModulesSettings from '../../../components/settings/ModulesSettings'
import PlansManagement from '../../../components/settings/PlansManagement'

interface SettingsPageProps {
    selectedTab: string
}

const SettingsPage: React.FC<SettingsPageProps> = ({ selectedTab }) => {
    const location = useLocation()
    const [isScrolled, setIsScrolled] = useState(false)
    const [accessTab, setAccessTab] = useState('admins')

    // Check if we're returning from a role detail page with a specific tab to show
    useEffect(() => {
        if (location.state?.selectedTab) {
            setAccessTab(location.state.selectedTab)
        }
    }, [location.state])

    const renderTable = () => {
        if (selectedTab === 'general') {
            return <OrganizationSettings />
        }
        if (selectedTab === 'access') {
            return <SettingsTable selectedTab={accessTab} onSelectTab={setAccessTab} />
        }
        if (selectedTab === 'payments') {
            return <PaymentsSettings />
        }
        if (selectedTab === 'modules') {
            return <ModulesSettings />
        }
        if (selectedTab === 'organizations') {
            return <OrganizationsSettings />
        }
        if (selectedTab === 'plans') {
            return <PlansManagement />
        }
        return null
    }

    const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
        setIsScrolled(event.currentTarget.scrollTop > 0)
    }

    return (
        <Flex
            flexDirection={{ base: 'column', md: 'row' }}
            height="100%"
            overflowY="auto"
            onScroll={handleScroll}
            borderRadius={isScrolled ? '10px' : '0'}
        >
            <VStack gap={{ base: '12px', md: '16px' }} width="100%">
                {renderTable()}
            </VStack>
        </Flex>
    )
}

export default SettingsPage
